import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,428.265749 L1920,1617.80519 L1455.83907,1037.66049 L1367.6372,1108.24457 L1836.31551,1694.14893 L83.6844891,1694.14893 L552.362802,1108.24457 L464.160932,1037.66049 L0,1617.80519 L0,428.265749 L959.943533,1260.70619 L1920,428.265749 Z M1919.93224,226 L1919.93224,278.627493 L959.988707,1111.06794 L0.0451738133,278.627493 L0.0451738133,226 L1919.93224,226 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEmailSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEmailSolid, _Component);

  var _super = _createSuper(IconEmailSolid);

  function IconEmailSolid() {
    _classCallCheck(this, IconEmailSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEmailSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEmail",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEmailSolid.displayName = "IconEmailSolid";
  return IconEmailSolid;
}(Component);

IconEmailSolid.glyphName = 'email';
IconEmailSolid.variant = 'Solid';
IconEmailSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEmailSolid;
export { IconEmailSolid };